import LeadContent from "pages/shared/lead-content/LeadContent"
import Loading from "pages/shared/loading/Loading"
import { useContext, useEffect, useState } from "react"
import { useTranslation } from 'react-i18next';
import { useErrorBoundary } from "react-error-boundary"
import { useNavigate, useParams } from "react-router"
import { NotificationContext } from "shared/NotificationContext"
import { useBackofficeApi } from 'shared/useBackofficeApi';
import { Lead, NotificationType } from "shared/topchef.types"

const AllLeadDetails = () => {

  const { t } = useTranslation();
  const navigate = useNavigate();
  
  const notificationContext = useContext(NotificationContext);
  const { triggerNotification } = notificationContext;

  const params = useParams();
  const leadId: string = params.leadId || '';

  const [isReady, setReady] = useState<boolean>(false);
  const [lead, setLead] = useState<Lead | null>(null);

  const { showBoundary } = useErrorBoundary();
  const backofficeApi = useBackofficeApi();

  useEffect(() => {
    setReady(false);
  }, [leadId, backofficeApi.country]);

  useEffect(() => { // eslint-disable-line react-hooks/exhaustive-deps

    async function loadLead() {
      try {
        const lead: Lead = await backofficeApi.loadLeadDetails(leadId);
        setLead(lead);
        setReady(true);
      } catch (error: any) { 
        const newError = new Error(t('apiErrors.loadLead', { details: error.message }) as string);
        triggerNotification({type: NotificationType.error, message : newError.message}); 
        showBoundary(newError);
      } 
    }

    if (isReady) {
      return;
    }

    loadLead();

  }, [isReady, leadId, backofficeApi, showBoundary, triggerNotification]); // eslint-disable-line react-hooks/exhaustive-deps


  const backToAllLeads = async () => {
    navigate('/backoffice/leads/all');
  };


  if (!isReady|| !lead) {
    return (
      <Loading />
    );
  }

  const goToEdit = () => {
    navigate(`/backoffice/leads/edit/${leadId}`);
  };

  
  return (
    <div className="container p-2 col-md-6 overflow-auto">

      <LeadContent lead={lead!} />

      <div className="text-center">
        <div className="text-center btn-list">
          <button className="btn btn-primary m-3 edit-brief-btn" onClick={goToEdit}>{t('allLeadDetails.editBrief')}</button>
          <button className="btn btn-primary m-3" onClick={backToAllLeads}>{t('common.backToBriefs')}</button> 
        </div>
      </div>

    </div>
  );

}

export default AllLeadDetails;